import React from "react";
import BannerImage from "../../../assets/images/aboutusbg.png";
import Banner from "../banner";

const Main = () => {
  return (
    <>
      <Banner
        img={BannerImage}
        title="Is Bright Airways Real or Fake?"
      />
      <div className="container mt-4 mb-4">
        <article className="blog-article">
          <header className="mb-4">
            <h3 className="fw-bold">Introduction</h3>
            <p>
              In recent times, many job seekers searching online for aviation careers have asked an important question:
              <strong> “Is Bright Airways real or fake?”</strong>
            </p>
            <p>
              This article is an official clarification from Bright Airways to address concerns, remove confusion, and provide complete transparency about who we are, what we do, and how our aviation job assistance process works.
            </p>
            <p>
              Due to the rise in aviation job scams in India, it has become essential for candidates to verify every organization carefully. We strongly support this approach and encourage job seekers to stay informed, alert, and aware.
            </p>
            <p>
              This blog is written to help candidates clearly understand Bright Airways role in the aviation sector, how to identify genuine opportunities, and how to avoid fraudulent job offers.
            </p>
          </header>

          <section className="mb-4">
            <h3 className="fw-semibold">Who We Are – About Bright Airways</h3>
            <p>Bright Airways is a private aviation recruitment, career guidance, and staffing support organization.</p>
            <div className="row">
              <div className="col-md-6">
                <h5 className="text-success fw-bold">We are:</h5>
                <ul>
                  <li>✅ A career support and recruitment assistance company</li>
                  <li>✅ Focused on aviation and travel-related job roles</li>
                  <li>✅ Committed to ethical, transparent, and professional practices</li>
                </ul>
              </div>
              <div className="col-md-6">
                <h5 className="text-danger fw-bold">We are NOT:</h5>
                <ul>
                  <li>❌ An airline</li>
                  <li>❌ A flight operator</li>
                  <li>❌ A government aviation body</li>
                  <li>❌ An organization that guarantees jobs or issues airline appointment letters</li>
                </ul>
              </div>
            </div>
            <p className="mt-2">
              Our role is to assist eligible candidates by preparing them for aviation-sector opportunities and connecting them with potential employers based on their skills, eligibility, and interview performance.
            </p>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">Why Are People Searching “Bright Airways Real or Fake?”</h3>
            <p>Searches like “Bright Airways job real or fake” usually happen due to the following reasons:</p>
            <ul>
              <li>High number of fake aviation job scams online</li>
              <li>Misuse of aviation-related names by fraudsters</li>
              <li>Fake WhatsApp calls claiming “direct airline jobs”</li>
              <li>Candidates being asked to pay money for fake offer letters</li>
              <li>Lack of awareness about how aviation recruitment actually works</li>
            </ul>
            <p>We understand these concerns and believe questioning is healthy. This article exists to answer those questions honestly.</p>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">What Services Does Bright Airways Provide?</h3>
            <p>Bright Airways works in the aviation career support and recruitment assistance space, which may include:</p>
            <ul>
              <li>Aviation career counseling</li>
              <li>Resume and profile screening</li>
              <li>Interview preparation and grooming guidance</li>
              <li>Aviation training support (where applicable)</li>
              <li>Coordination with hiring partners</li>
              <li>Career guidance for airport and aviation-related roles</li>
            </ul>
            <p><strong>👉 Final selection and hiring decisions are always made by the employer, not by Bright Airways.</strong></p>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">Do We Provide Direct Airline Jobs?</h3>
            <p><strong>No.</strong></p>
            <p>
              Bright Airways does not provide direct airline jobs, does not conduct airline hiring on behalf of airlines, and does not issue airline offer letters.
            </p>
            <p>
              Airlines and airports follow their own recruitment policies, interviews, and selection processes. Any organization claiming “guaranteed airline jobs” or “direct offer letters” should be treated with caution.
            </p>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">Do We Guarantee Jobs?</h3>
            <p><strong>No genuine aviation organization can guarantee a job.</strong></p>
            <p>Bright Airways:</p>
            <ul>
              <li>❌ Does not guarantee placement</li>
              <li>❌ Does not promise selection</li>
              <li>❌ Does not sell job offers</li>
            </ul>
            <p>We support candidates by improving their readiness and eligibility, but selection depends entirely on the employer.
            </p>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">Our Recruitment Support Process (Transparent & Ethical)</h3>
            <p>To help candidates understand how we work, here is our general process:</p>
            <ol>
              <li><strong>Candidate Registration:</strong> Interested candidates submit their profile through our official website or office.</li>
              <li><strong>Profile Screening:</strong> We review eligibility based on role requirements such as age, education, communication skills, and basic fitness.</li>
              <li><strong>Career Guidance & Preparation:</strong> Candidates may receive guidance on interviews, documentation, and professional presentation.</li>
              <li><strong>Opportunity Sharing:</strong> Suitable opportunities are shared based on availability and employer requirements.</li>
              <li><strong>Interview Coordination:</strong> Candidates attend interviews conducted by employers or authorized partners.</li>
              <li><strong>Final Employer Decision:</strong> Selection or rejection is solely decided by the hiring organization.</li>
            </ol>
          </section>

          <section className="mb-4 bg-light p-4 rounded border-start border-4 border-warning">
            <h3 className="fw-semibold">Important Disclaimer</h3>
            <p>To avoid any misunderstanding, we clearly state:</p>
            <ul>
              <li>Bright Airways is not an airline</li>
              <li>We do not issue airline appointment letters</li>
              <li>We do not claim affiliation with any airline unless officially documented</li>
              <li>We do not authorize third-party agents to collect money in our name</li>
              <li>We do not conduct hiring via WhatsApp or unofficial calls</li>
            </ul>
            <p>Candidates should communicate only through official Bright Airways contact details published on our website.</p>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold text-danger">Warning About Fake Aviation Job Scams</h3>
            <p>The aviation industry has unfortunately seen a rise in fraud cases. Common scam tactics include:</p>
            <ul>
              <li>Fake offer letters using airline logos</li>
              <li>WhatsApp calls claiming “HR from airline”</li>
              <li>Requests for registration or training fees with job promises</li>
              <li>Emails from non-official domains</li>
              <li>Pressure to make immediate payments</li>
            </ul>
            <div className="alert alert-danger">
              🚨 <strong>Bright Airways strongly advises candidates to never pay money for job guarantees.</strong>
            </div>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">How to Verify a Genuine Aviation Job Opportunity</h3>
            <p>Before trusting any aviation job offer, candidates should:</p>
            <ul>
              <li>Verify the company’s official website</li>
              <li>Check office address and contact details</li>
              <li>Look for transparency and disclaimers</li>
              <li>Avoid urgency or pressure tactics</li>
              <li>Never trust job offers without interviews</li>
              <li>Cross-check information with official airline websites</li>
            </ul>
            <p>A genuine organization will never hide its identity.</p>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">Is Bright Airways Registered and Legit?</h3>
            <p>Bright Airways operates as a registered private organization providing aviation career support services.</p>
            <p>We believe legitimacy comes from Transparency, Clear communication, Ethical practices, and Public accountability.</p>
            <p>We welcome candidates to visit our office, speak to our team, and ask questions before making any decisions.</p>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">What to Do If Someone Misuses the Name “Bright Airways”</h3>
            <p>If anyone contacts you claiming to represent Bright Airways and asks for money, promises guaranteed airline jobs, or sends fake offer letters, please understand:</p>
            <div className="alert alert-info">
              👉 <strong>They are not associated with us.</strong>
            </div>
            <p>We encourage candidates to report such misuse and verify directly with our official channels.</p>
          </section>

          <footer className="mt-4 pt-4 border-top">
            <h3 className="fw-bold">Contact Bright Airways (Official Channels Only)</h3>
            <p>For genuine information, always contact Bright Airways through:</p>
            <ul>
              <li><strong>Website:</strong> <a href="https://www.brightairways.in">www.brightairways.in</a></li>
              <li><strong>Address:</strong> 10A, IOC Colony, Sector 10, Gurgaon 122001</li>
              <li><strong>Email:</strong> <a href="mailto:info@brightairways.in">info@brightairways.in</a></li>
            </ul>
          </footer>
        </article>
      </div>
    </>
  );
};

export default Main;
